import { gql } from "@apollo/client";
import { ComponentStateTypes } from "components/common/ComponentState";
import Page from "components/common/page/Page";
import FruitForm, { FruitFromType } from "components/entities/agriculture/fruit/FruitForm";
import { graph } from "config/axios-context";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetFruitQuery, GetFruitQueryVariables } from "types/graphql";
import { useContext } from "react";
import { getAppContext } from 'config/AppContext';

const getFruitQuery = gql`
query GetFruit($id: Int) {
    fruit(id:$id) {
      id,
      name,
      categories {
        items {
          name,
          id
        }
      }
      groups {
        items {
          name,
          id
        }
      }
    }
  }
`;

const FruitFormPage = () => {
    const context = getAppContext(useContext);
    const params = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [state, setState] = useState<ComponentStateTypes>(params.id ? 'loading' : '');
    const [fruit, setFruit] = useState<FruitFromType>();

    useEffect(() => {
        if (Number(params.id)) {
            loadData().then();
        }
    }, [])

    const loadData = async () => {
        setState('loading');
        try {
            const response = await graph<GetFruitQuery, GetFruitQueryVariables>({
                query: getFruitQuery,
                variables: {
                    id: Number(params.id!)
                }
            });

            if (response.data?.fruit) setFruit({
                id: response.data!.fruit.id,
                name: response.data!.fruit.name,
                categories: response.data!.fruit.categories!.items as any,
                groups: response.data!.fruit.groups!.items as any
            });
            setState('');
        } catch (error) {
            setState('error');
            context.notify('error', 'error.loading-data')
            throw error;
        }
    }

    return (
        <Page title="pages.agriculture.fruit.form" state={state}>
            <FruitForm onSubmit={() => navigate(-1)} model={fruit} name="fruit-form-page" />
        </Page>
    );
};

export default FruitFormPage;
